/**
 * Brewery data for the beer festival app
 * Breweries are now loaded dynamically from Directus CMS
 */

export interface Brewery {
  id: string;
  name: string;
  description: string;
  location: {
    address: string;
    town: string;
    postcode: string;
    latitude: number;
    longitude: number;
  };
  website?: string;
  shopUrl?: string;
  socialMedia?: {
    twitter?: string;
    instagram?: string;
    facebook?: string;
  };
  logoUrl?: string;
  heroImageUrl?: string;
  established?: number;
}

// Default hero image for breweries without a custom one
export const DEFAULT_HERO_IMAGE = 'https://scontent-man2-1.xx.fbcdn.net/v/t39.30808-6/432871049_807843411382546_4510004957137993103_n.png?_nc_cat=111&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=DsglbE_29hwQ7kNvwHd1Noy&_nc_oc=Adm3_AvZwFQS_2NTyqdAyTzMi53m6VRu_1H5c1iE40l3NHynR-PhSyMFMtVEgEQxvlY&_nc_zt=23&_nc_ht=scontent-man2-1.xx&_nc_gid=hJQ1gRXjeUxGXaFOUR5MAA&oh=00_AfvXPCGFAKWfj_gg3g0GxyDPzU8Y1DMVBrVxp00CGGc7jg&oe=698A9AEB';

// Dynamic breweries loaded from Directus
let dynamicBreweries: Brewery[] = [];

export function setDynamicBreweries(newBreweries: Brewery[]): void {
  dynamicBreweries = newBreweries;
}

const normaliseBreweryName = (name: string): string => {
  return name
    .normalize('NFKC')
    .replace(/[’`]/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
};

/**
 * Get a brewery by its name (case-insensitive match)
 */
export function getBreweryByName(name: string): Brewery | undefined {
  const targetName = normaliseBreweryName(name);
  return dynamicBreweries.find(b => normaliseBreweryName(b.name) === targetName);
}

/**
 * Get a brewery by its ID
 */
export function getBreweryById(id: string): Brewery | undefined {
  return dynamicBreweries.find(b => b.id === id);
}

/**
 * Convert a brewery name to a URL-friendly ID
 */
export function breweryNameToId(name: string): string {
  return name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
}
